import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import type { PathCategory } from '@storefront/lib-global/codegen/types';
import { Breadcrumb, Item } from './ProductBreadcrumb.styles';

type ProductBreadcrumbProps = {
  categoriesPath: PathCategory[];
};

export function ProductBreadcrumb({ categoriesPath }: ProductBreadcrumbProps) {
  const { t } = useTranslation(['lib-products-common']);
  const breadcrumb = [{ key: '', name: t('pdp.breadcrumbs.home'), slug: 'home' }].concat(categoriesPath);

  return (
    <Breadcrumb aria-label={t('breadcrumbs.title')}>
      <ol>
        {breadcrumb.map(({ key, name }, index) => (
          <Item key={`${name}-${index}`}>
            <Link href={`/${key}${index === 0 ? '' : '-c'}`} legacyBehavior passHref>
              {/* It was necessary to create a new <a> tag because NextLink doesn't support the aria-current attribute. */}
              <a {...(index + 1 === breadcrumb.length ? { 'aria-current': 'page' } : {})}>{name}</a>
            </Link>
          </Item>
        ))}
      </ol>
    </Breadcrumb>
  );
}

export default ProductBreadcrumb;
